import Api from './api.service'

export default {
  get () {
    return Api().get('config')
  },
}
